import {commonControllers} from '@mintdata-wsp/common/controllers/CommonControllers';
import {API} from '@mintdata-wsp/common/controllers/network/WorkspaceAPI';
import {rootState} from '@mintdata-wsp/common/state/RootState';
import {VersionState} from '@mintdata-wsp/common/state/UIState';
import {action} from 'mobx';

export interface IApplicationVersion
{
    number:number;
    release:string;
    startTimeInMillis:number;
    startTime:string;
    sources?:{
        [branchName:string]:string,
    }
}

export interface IApplicationUnknownVersion
{
    version:string;
}

export class BuildVersionController
{
    public init()
    {
        if( commonControllers.context.isStandaloneMode() )
        {
            rootState.ui.version = new VersionState();
            return;
        }

        try
        {
            API.version
                .getVersion()
                .then(value => this.processBuildVersionJson(value as any))
                .catch(reason => console.error(reason));
        }
        catch( e )
        {
            console.error(e);
        }
    }

    @action
    private processBuildVersionJson(versionJson:IApplicationVersion | IApplicationUnknownVersion)
    {
        try
        {
            const vs = rootState.ui.version = new VersionState();

            const applicationUnknownVersion = versionJson as IApplicationUnknownVersion;
            if( applicationUnknownVersion && applicationUnknownVersion.version )
            {
                vs.isLocalDevMode = true;
                vs.startTime = '';
                vs.startTimeInMillis = 0;
            }

            const applicationVersion = versionJson as IApplicationVersion;
            if( applicationVersion && applicationVersion.number )
            {
                vs.isLocalDevMode = false;
                vs.number = applicationVersion.number;
                vs.release = applicationVersion.release;
                vs.startTime = applicationVersion.startTime;
                vs.startTimeInMillis = applicationVersion.startTimeInMillis;
            }

            rootState.ui.version = vs;
        }
        catch( e )
        {
            console.error(e);
        }
    }
}
